export const log2n = (value: bigint): bigint => {
    return BigInt(Math.log2(Number(value)));
}
